<template>
  <div
    role="group"
    class="flex items-center justify-center gap-2 w-[120px] h-[40px] tabular-nums whitespace-nowrap font-semibold cursor-default [&_span]:!text-inherit"
    :class="outcome === 'yes' ? 'text-[var(--p-yes)]' : 'text-[var(--p-no)]'"
    :aria-label="t(outcome)"
  >
    <span>{{ t(outcome) }}</span>
    <BidAskCell
      :conid="outcome === 'yes' ? contract.conid_yes : contract.conid_no"
      :exchange="contract.exchange"
      :conid-ex-pairs="conidExPairs"
      :side="priceSide"
      :enabled="enabled"
      :seed="seed"
      seedMode
      format="dollars"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BidAskCell from '@/markets/BidAskCell.vue';
import type { PredictionContractListContract } from '@/types/prediction.types';

withDefaults(
  defineProps<{
    contract: PredictionContractListContract;
    outcome: 'yes' | 'no';
    priceSide: 'bid' | 'ask';
    conidExPairs?: string[];
    seed?: number;
    enabled?: boolean;
  }>(),
  { enabled: true },
);

const { t } = useI18n();
</script>
